// @genesys-custom-file
'use client';

import { c as _c } from "react/compiler-runtime";
import { Toaster as SonnerToaster } from 'sonner';
export function Toaster() {
  const $ = _c(2);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      bottom: 0,
      right: 0
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <SonnerToaster richColors={true} position="bottom-right" offset={t0} theme="dark" toastOptions={{
      duration: 4000,
      style: {
        background: "var(--background)",
        border: "none"
      }
    }} />;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
}